// extracted by mini-css-extract-plugin
export default {"root":"_3xyQr","animator":"_2u9E-","notification-link":"_3glCa","notificationLink":"_3glCa"};